<div
  class="flex flex-1 flex-col m-4 p-6 sm:p-8 bg-base-100 rounded-xl shadow-sm min-h-0"
  data-testid="error-page-card"
>
  <div
    class="view-error-state flex-1"
    [code]="stateCode()"
    [deviceType]="breakpointService.deviceType()"
    [testId]="testId()"
  ></div>
</div>
